'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var MIME_TYPES = exports.MIME_TYPES = {
    PDF: 'application/pdf',
    HTML: 'text/html',
    DOCX: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    MARKDOWN: 'text/markdown; charset=UTF-8',
    PLAIN_TEXT: 'text/plain; charset=UTF-8',
    // Images
    GIF: 'image/gif',
    JPEG: 'image/jpeg',
    PNG: 'image/png'
};


//////////////////
// WEBPACK FOOTER
// ./src/common/media/mimeConstants.js
// module id = 798
// module chunks = 0